// libs
import { createContext, useContext } from 'react';

interface ConfirmRedirectContext {
  showConfirm: (onConfirm: VoidFunction, onCancel?: VoidFunction) => void;
}

const EMPTY_FUNC = () => {
  /** DO NOTHING */
};

const initialValue: ConfirmRedirectContext = {
  showConfirm: EMPTY_FUNC,
};

const confirmRedirectContext = createContext(initialValue);

export const useConfirmRedirect = () => useContext(confirmRedirectContext);

export default confirmRedirectContext;
